// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  display: flex;
  font-family: Arial, sans-serif;
}

/* Sidebar */
.sidebar {
  width: 220px;
  background: #f9f9f9;
  border-right: 1px solid #ddd;
  padding: 10px;
}

.search-box {
  margin-bottom: 10px;
}

.customer-list {
  border: 1px solid #ccc;
  background: #fff;
  padding: 5px;
  overflow-y: auto;
}

.customer-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.customer-list li {
  padding: 5px;
  cursor: pointer;
}

.customer-list li:hover {
  background: #e6f0ff;
}

/* Main Content */
.main-content {
  flex: 1;
  padding: 0px 15px 15px 15px;
  overflow-y: auto;
}

.summary-title {
  text-align: center;
  color: #36f;
  margin-bottom: 10px;
}

.top-section,
.bottom-section {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.card {
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff !important;
  background-clip: border-box;
  border: 1px solid #c8ced3;
  margin-bottom: 0rem;
  box-shadow: 0 1px 4px 0 rgba(84, 90, 97, 0.9294117647);
}

.card .card-title {
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}

.chart-card {
  flex: 2;
  min-height: 250px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: #1976d2;
  color: #fff;
}

th,
td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: left;
}

.chart-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 300px;
  margin: auto;
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.chart-container canvas {
  max-width: 550px;
  max-height: 250px;
}

.table-container {
  max-height: 205px;
  overflow-y: auto;
  overflow-x: hidden;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
}

.table-container thead {
  position: sticky;
  top: 0;
  background: #1976d2;
  color: #fff;
  z-index: 2;
}

.list-group {
  max-height: 75vh;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/policydetails/my-policies-search/my-policies-search.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,8BAAA;AAAF;;AAGA,YAAA;AACA;EACE,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,gBAAA;EACA,YAAA;EAEA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA,iBAAA;AACA;EACE,OAAA;EACA,2BAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;;EAEE,aAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,sDAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAGA;EACE,OAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WAAA;AAAF;;AAGA;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;AAAF","sourcesContent":[".dashboard-container {\n  display: flex;\n  //   height: 100vh;\n  font-family: Arial, sans-serif;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 220px;\n  background: #f9f9f9;\n  border-right: 1px solid #ddd;\n  padding: 10px;\n}\n\n.search-box {\n  margin-bottom: 10px;\n}\n\n.customer-list {\n  border: 1px solid #ccc;\n  background: #fff;\n  padding: 5px;\n  //   height: calc(100vh - 80px);\n  overflow-y: auto;\n}\n\n.customer-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.customer-list li {\n  padding: 5px;\n  cursor: pointer;\n}\n\n.customer-list li:hover {\n  background: #e6f0ff;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  padding: 0px 15px 15px 15px;\n  overflow-y: auto;\n}\n\n.summary-title {\n  text-align: center;\n  color: #36f;\n  margin-bottom: 10px;\n}\n\n.top-section,\n.bottom-section {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.card {\n  border-radius: 5px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff !important;\n  background-clip: border-box;\n  border: 1px solid #c8ced3;\n  margin-bottom: 0rem;\n  box-shadow: 0 1px 4px 0 #545a61ed;\n}\n\n.card .card-title {\n  font-weight: bold;\n  margin-bottom: 15px;\n  text-align: center;\n}\n.chart-card {\n  flex: 2;\n  min-height: 250px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background: #1976d2;\n  color: #fff;\n}\n\nth,\ntd {\n  border: 1px solid #ccc;\n  padding: 6px;\n  text-align: left;\n}\n\n.chart-container {\n  position: relative;\n  width: 100%;\n  max-width: 600px;\n  height: 300px;\n  margin: auto;\n  background: #fff;\n  padding: 10px;\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.chart-container canvas {\n  max-width: 550px;\n  max-height: 250px;\n}\n\n.table-container {\n  max-height: 205px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.table-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-container thead {\n  position: sticky;\n  top: 0;\n  background: #1976d2;\n  color: #fff;\n  z-index: 2;\n}\n\n.list-group {\n  max-height: 75vh;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
